import { createContext } from 'react';

import { Form, FormAttachment, TemplateType } from 'types';

type FormEditContextType = {
  form: Form;
  attachments: FormAttachment[];
  template?: TemplateType;
  refetchAttachment: () => Promise<unknown>;
};

export const FormEditContext = createContext<FormEditContextType | null>(null);
